// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Receipt_modal__ZTBKE {
  position: absolute;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
}

.Receipt_upper__ZIglv {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.Receipt_upper__icon__lYwye {
  font-size: 5rem;
  color: var(--color-primary);
  cursor: pointer;
}
.Receipt_upper__icon__lYwye:hover, .Receipt_upper__icon__lYwye:focus {
  color: var(--color-primary-4);
}
.Receipt_upper__search__5\\+in\\+ {
  position: relative;
  top: -1.3rem;
}

.Receipt_receipt__list__gznNQ {
  margin-top: 2rem;
  display: flex;
  position: relative;
}
.Receipt_receipt__beside__hh3Ut {
  display: flex;
  justify-content: space-between;
}
.Receipt_receipt__checks__UKVO\\+ {
  display: flex;
  justify-content: space-between;
  margin: 1rem 0 2rem 0;
}

.Receipt_table__4OQpE {
  width: 100%;
  max-width: 100%;
  border: none;
  border-collapse: collapse;
  box-sizing: border-box;
  text-align: left;
}
.Receipt_table__4OQpE th,
.Receipt_table__4OQpE td {
  padding: 2.2rem 0;
}
.Receipt_table__4OQpE th {
  font-weight: 700;
}
.Receipt_table__4OQpE tr {
  display: grid;
  grid-template-columns: 1fr 1.2fr 2.2fr 2.4fr 1.2fr;
  padding: 0 3rem;
}
.Receipt_table__4OQpE tbody > :not(:last-child) {
  margin-bottom: 1.5rem;
}
.Receipt_table__4OQpE tbody tr {
  background-color: var(--color-primary-3);
  cursor: pointer;
  border-radius: 1.3rem;
}
.Receipt_table__4OQpE tbody tr:nth-child(even) {
  background-color: var(--color-primary-7);
}

.Receipt_minMenu__axGb0 {
  color: var(--color-primary);
  cursor: pointer;
  font-size: 2rem;
}

.Receipt_sideButton__8nJ1v {
  display: flex;
  margin-top: 3rem;
}

.Receipt_summary__AAGTR {
  width: 42rem;
  margin-top: 2rem;
}
.Receipt_summary__title__35ZOx {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.Receipt_summary__edit__8\\+bJq {
  display: flex;
  align-items: flex-end;
  color: var(--color-dark);
  font-size: var(--default-font-small);
  cursor: pointer;
}
.Receipt_summary__edit__8\\+bJq > :last-child {
  font-size: 3rem;
  color: var(--color-primary);
}
.Receipt_summary__edit__8\\+bJq:hover, .Receipt_summary__edit__8\\+bJq:focus {
  color: var(--color-primary-4);
  font-weight: 700;
}
.Receipt_summary__line__\\+bw0- {
  border-top: 1px solid var(--color-primary);
  margin: 2rem 0;
}
.Receipt_summary__beside__zYTrO {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.Receipt_summary__dates__3f\\+92 {
  display: flex;
  justify-content: space-between;
  margin-bottom: 2rem;
}
.Receipt_summary__dates__3f\\+92 > :not(:last-child) {
  margin-right: 2rem;
}
.Receipt_summary__details__jF5hP {
  color: var(--color-primary);
}
.Receipt_summary__total__yQsLM {
  display: grid;
  grid-template-columns: 1.3fr 1fr;
  gap: 2rem;
  margin-bottom: 1rem;
}
.Receipt_summary__account__kPfpg {
  display: grid;
  grid-template-columns: 1.3fr 1fr;
  gap: 1rem;
  margin: 2rem 0;
}
.Receipt_summary__button__GXtVl {
  display: flex;
  gap: 2rem;
}`, "",{"version":3,"sources":["webpack://./src/assets/styles/Receipt/Receipt.module.scss"],"names":[],"mappings":"AAAA;EACC,kBAAA;EACA,OAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;AACD;;AAEA;EACC,aAAA;EACA,8BAAA;EACA,mBAAA;AACD;AACC;EACC,eAAA;EACA,2BAAA;EACA,eAAA;AACF;AACE;EAEC,6BAAA;AAAH;AAIC;EACC,kBAAA;EACA,YAAA;AAFF;;AAOC;EACC,gBAAA;EACA,aAAA;EACA,kBAAA;AAJF;AAOC;EACC,aAAA;EACA,8BAAA;AALF;AAQC;EACC,aAAA;EACA,8BAAA;EACA,qBAAA;AANF;;AAYA;EACC,WAAA;EACA,eAAA;EACA,YAAA;EACA,yBAAA;EACA,sBAAA;EACA,gBAAA;AATD;AAWC;;EAEC,iBAAA;AATF;AAYC;EACC,gBAAA;AAVF;AAaC;EACC,aAAA;EACA,kDAAA;EACA,eAAA;AAXF;AAeE;EACC,qBAAA;AAbH;AAgBE;EACC,wCAAA;EACA,eAAA;EACA,qBAAA;AAdH;AAgBG;EACC,wCAAA;AAdJ;;AAoBA;EACC,2BAAA;EACA,eAAA;EACA,eAAA;AAjBD;;AAqBA;EACC,aAAA;EACA,gBAAA;AAlBD;;AAsBA;EACC,YAAA;EACA,gBAAA;AAnBD;AAoBC;EACC,aAAA;EACA,8BAAA;EACA,mBAAA;AAlBF;AAqBC;EACC,aAAA;EACA,qBAAA;EACA,wBAAA;EACA,oCAAA;EACA,eAAA;AAnBF;AAqBE;EACC,eAAA;EACA,2BAAA;AAnBH;AAsBE;EAEC,6BAAA;EACA,gBAAA;AArBH;AAyBC;EACC,0CAAA;EACA,cAAA;AAvBF;AA0BC;EACC,aAAA;EACA,8BAAA;EACA,mBAAA;AAxBF;AA2BC;EACC,aAAA;EACA,8BAAA;EACA,mBAAA;AAzBF;AA0BE;EACC,kBAAA;AAxBH;AA4BC;EACC,2BAAA;AA1BF;AA6BC;EACC,aAAA;EACA,gCAAA;EACA,SAAA;EACA,mBAAA;AA3BF;AA8BC;EACC,aAAA;EACA,gCAAA;EACA,SAAA;EACA,cAAA;AA5BF;AA+BC;EACC,aAAA;EACA,SAAA;AA7BF","sourcesContent":[".modal {\n\tposition: absolute;\n\tleft: 0;\n\ttop: 0;\n\tright: 0;\n\tbottom: 0;\n}\n\n.upper {\n\tdisplay: flex;\n\tjustify-content: space-between;\n\talign-items: center;\n\n\t&__icon {\n\t\tfont-size: 5rem;\n\t\tcolor: var(--color-primary);\n\t\tcursor: pointer;\n\n\t\t&:hover,\n\t\t&:focus {\n\t\t\tcolor: var(--color-primary-4);\n\t\t}\n\t}\n\n\t&__search {\n\t\tposition: relative;\n\t\ttop: -1.3rem;\n\t}\n}\n\n.receipt {\n\t&__list {\n\t\tmargin-top: 2rem;\n\t\tdisplay: flex;\n\t\tposition: relative;\n\t}\n\n\t&__beside {\n\t\tdisplay: flex;\n\t\tjustify-content: space-between;\n\t}\n\n\t&__checks {\n\t\tdisplay: flex;\n\t\tjustify-content: space-between;\n\t\tmargin: 1rem 0 2rem 0;\n\t}\n}\n\n//Table styles start\n\n.table {\n\twidth: 100%;\n\tmax-width: 100%;\n\tborder: none;\n\tborder-collapse: collapse;\n\tbox-sizing: border-box;\n\ttext-align: left;\n\n\tth,\n\ttd {\n\t\tpadding: 2.2rem 0;\n\t}\n\n\tth {\n\t\tfont-weight: 700;\n\t}\n\n\ttr {\n\t\tdisplay: grid;\n\t\tgrid-template-columns: 1fr 1.2fr 2.2fr 2.4fr 1.2fr;\n\t\tpadding: 0 3rem;\n\t}\n\n\ttbody {\n\t\t& > :not(:last-child) {\n\t\t\tmargin-bottom: 1.5rem;\n\t\t}\n\n\t\ttr {\n\t\t\tbackground-color: var(--color-primary-3);\n\t\t\tcursor: pointer;\n\t\t\tborder-radius: 1.3rem;\n\n\t\t\t&:nth-child(even) {\n\t\t\t\tbackground-color: var(--color-primary-7);\n\t\t\t}\n\t\t}\n\t}\n}\n\n.minMenu {\n\tcolor: var(--color-primary);\n\tcursor: pointer;\n\tfont-size: 2rem;\n}\n//Table styles end\n\n.sideButton {\n\tdisplay: flex;\n\tmargin-top: 3rem;\n}\n\n//Summary Styles\n.summary {\n\twidth: 42rem;\n\tmargin-top: 2rem;\n\t&__title {\n\t\tdisplay: flex;\n\t\tjustify-content: space-between;\n\t\talign-items: center;\n\t}\n\n\t&__edit {\n\t\tdisplay: flex;\n\t\talign-items: flex-end;\n\t\tcolor: var(--color-dark);\n\t\tfont-size: var(--default-font-small);\n\t\tcursor: pointer;\n\n\t\t& > :last-child {\n\t\t\tfont-size: 3rem;\n\t\t\tcolor: var(--color-primary);\n\t\t}\n\n\t\t&:hover,\n\t\t&:focus {\n\t\t\tcolor: var(--color-primary-4);\n\t\t\tfont-weight: 700;\n\t\t}\n\t}\n\n\t&__line {\n\t\tborder-top: 1px solid var(--color-primary);\n\t\tmargin: 2rem 0;\n\t}\n\n\t&__beside {\n\t\tdisplay: flex;\n\t\tjustify-content: space-between;\n\t\talign-items: center;\n\t}\n\n\t&__dates {\n\t\tdisplay: flex;\n\t\tjustify-content: space-between;\n\t\tmargin-bottom: 2rem;\n\t\t& > :not(:last-child) {\n\t\t\tmargin-right: 2rem;\n\t\t}\n\t}\n\n\t&__details {\n\t\tcolor: var(--color-primary);\n\t}\n\n\t&__total {\n\t\tdisplay: grid;\n\t\tgrid-template-columns: 1.3fr 1fr;\n\t\tgap: 2rem;\n\t\tmargin-bottom: 1rem;\n\t}\n\n\t&__account {\n\t\tdisplay: grid;\n\t\tgrid-template-columns: 1.3fr 1fr;\n\t\tgap: 1rem;\n\t\tmargin: 2rem 0;\n\t}\n\n\t&__button {\n\t\tdisplay: flex;\n\t\tgap: 2rem;\n\t}\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"modal": `Receipt_modal__ZTBKE`,
	"upper": `Receipt_upper__ZIglv`,
	"upper__icon": `Receipt_upper__icon__lYwye`,
	"upper__search": `Receipt_upper__search__5+in+`,
	"receipt__list": `Receipt_receipt__list__gznNQ`,
	"receipt__beside": `Receipt_receipt__beside__hh3Ut`,
	"receipt__checks": `Receipt_receipt__checks__UKVO+`,
	"table": `Receipt_table__4OQpE`,
	"minMenu": `Receipt_minMenu__axGb0`,
	"sideButton": `Receipt_sideButton__8nJ1v`,
	"summary": `Receipt_summary__AAGTR`,
	"summary__title": `Receipt_summary__title__35ZOx`,
	"summary__edit": `Receipt_summary__edit__8+bJq`,
	"summary__line": `Receipt_summary__line__+bw0-`,
	"summary__beside": `Receipt_summary__beside__zYTrO`,
	"summary__dates": `Receipt_summary__dates__3f+92`,
	"summary__details": `Receipt_summary__details__jF5hP`,
	"summary__total": `Receipt_summary__total__yQsLM`,
	"summary__account": `Receipt_summary__account__kPfpg`,
	"summary__button": `Receipt_summary__button__GXtVl`
};
export default ___CSS_LOADER_EXPORT___;
